import { memo } from 'react';
import { DialogTrigger } from 'react-aria-components';

import { merge } from '@/components';
import { Button, Heading, Text } from '@/components/core';
import { AddIcon } from '@/components/icons';
import { InviteMembersModal, MembersTable } from '@/components/ui';
import { ManagedRole } from '@/constants';
import { DivProps } from '@/utils';

export type ReviewerSettingsProps = DivProps;

const IReviewerSettings = ({ className, ...rest }: ReviewerSettingsProps) => {
  return (
    <div className={merge('flex flex-col gap-2 p-4', className)} {...rest}>
      <div>
        <Heading>Reviewers</Heading>
        <Text>Invite your team to review documents that couldn't be automatically validated.</Text>
      </div>

      <MembersTable />

      <div>
        <DialogTrigger>
          <Button variant="plain">
            <AddIcon />
            <Text>Add reviewer</Text>
          </Button>
          <InviteMembersModal defaultRole={ManagedRole.Reviewer} />
        </DialogTrigger>
      </div>
    </div>
  );
};

export const ReviewerSettings = memo(IReviewerSettings) as typeof IReviewerSettings;
